import React from 'react'
import FormInput from './bases/FormInput'
import FormLabel from '../labels/FormLabel'
import { returnNumber } from 'helpers/numberHelpers'

const borderStyle = {
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  margin: '10px 15px',
  padding: 15,
}
const wrapperStyle = {
  position: 'relative',
  width: '100%',
  height: 200,
  paddingBottom: 40,
}

const fieldStyles = {
  base: { position: 'absolute' },
  topLeft: { top: 0, left: 0 },
  topRight: { top: 0, right: 0 },
  bottomLeft: { bottom: 0, left: 0 },
  bottomRight: { bottom: 0, right: 0 },
}

const inputStyles = {
  base: { width: 100, },
  left: { marginLeft: 45 },
  right: { marginRight: 45 },
}

const RadiusPicker = ({
  label,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  onChange,
  hasBorder,
}) => {
  const handleChange = (val, key) => {
    return returnNumber(val, (number) => onChange(number, key))
  }
  return (
    <div style={{ ...wrapperStyle, ...hasBorder && borderStyle }}>
      <FormLabel dark>{label}</FormLabel>
      <div style={{ ...fieldStyles.base, ...fieldStyles.topLeft }}>
        <FormInput
          style={inputStyles.base}
          label="Top Left"
          value={topLeft}
          onChange={(val) => handleChange(val, 'TopLeft')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.topRight }}>
        <FormInput
          style={inputStyles.base}
          label="Top Right"
          value={topRight}
          onChange={(val) => handleChange(val, 'TopRight')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.bottomLeft }}>
        <FormInput
          style={inputStyles.base}
          label="Bottom Left"
          value={bottomLeft}
          onChange={(val) => handleChange(val, 'BottomLeft')}
        />
      </div>
      <div style={{ ...fieldStyles.base, ...fieldStyles.bottomRight }}>
        <FormInput
          style={inputStyles.base}
          label="Bottom Right"
          value={bottomRight}
          onChange={(val) => handleChange(val, 'BottomRight')}
        />
      </div>
      <div
        style={{
          width: '62%',
          height: '38%',
          top: '39%',
          left: '19%',
          position: 'absolute',
          border: '3px solid #e8e8e8',
          borderRadius: 10,
        }}
      />
    </div>
  )
}

RadiusPicker.propTypes = {}
RadiusPicker.defaultProps = {}

export default RadiusPicker



// WEBPACK FOOTER //
// ./src/components/forms/RadiusPicker.js